import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Configurazione Firebase (stessa del progetto esistente)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// VAPID Key per Web Push
const VAPID_KEY = 'BBRofom1yBp2ddtXttqhRb0rniU_ZSIc68EWF4amVW3jqQ12Zn_uE5n-mauuAE_O0H1wxUbJZ0tMdVJXjmYlxwc';

// Inizializza Firebase app (se non già inizializzata)
let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Ottieni istanza messaging
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (error) {
  console.log('Firebase Messaging not supported in this browser');
}

// Richiedi permesso e ottieni token FCM
export const requestNotificationPermission = async () => {
  if (!messaging) {
    console.log('Messaging not available');
    return null;
  }

  try {
    // Richiedi permesso
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      // Registra service worker
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      
      // Ottieni token
      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: registration
      });
      
      console.log('FCM Token:', token);
      return token;
    } else {
      console.log('Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('Error getting notification permission:', error);
    return null;
  }
};

// Listener per messaggi in foreground
export const onForegroundMessage = (callback) => {
  if (!messaging) return () => {};
  
  return onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);
    callback(payload);
  });
};

export { messaging, VAPID_KEY };
